import type { ReactNode } from 'react';
import { Card } from '@/components/ui/card';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { QueryErrorState } from '@/components/admin/shared/QueryErrorState';

interface RelatedRecordsSectionProps {
  title: string;
  count?: number;
  actions?: ReactNode;
  isLoading: boolean;
  isError?: boolean;
  onRetry?: () => void;
  children: ReactNode;
}

export function RelatedRecordsSection({
  title,
  count,
  actions,
  isLoading,
  isError = false,
  onRetry,
  children,
}: RelatedRecordsSectionProps) {
  return (
    <Card>
      <div className="flex items-center justify-between gap-2 mb-4">
        <h2 className="text-sm font-bold text-zooindigo">
          {title}
          {count === undefined ? null : (
            <span className="text-zoomuted font-semibold"> · {count}</span>
          )}
        </h2>
        {actions === undefined ? null : <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {isLoading === true ? (
        <div className="py-8 flex justify-center">
          <LoadingSpinner className="w-6 h-6" />
        </div>
      ) : isError === true && onRetry !== undefined ? (
        <QueryErrorState onRetry={onRetry} />
      ) : (
        children
      )}
    </Card>
  );
}
